import type { Player, Position } from "../../../shared/models/Player";
import type { RankingsListKey } from "../../../shared/utils/xlsxRankings";

export type Tab = "Overall" | Position;
export type DesktopSourceTabVisibility = Record<RankingsListKey, boolean>;

export const DESKTOP_CONFIGURABLE_RANKING_TABS: RankingsListKey[] = ["Experts"];

export function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function getRiskRaw(player: Player): number | undefined {
  const value = (player as any).risk ?? (player as any).riskScore ?? (player as any).risk_score;
  return isFiniteNumber(value) ? value : undefined;
}

export function getUpsideRaw(player: Player): number | undefined {
  const value = (player as any).upside ?? (player as any).upsideScore ?? (player as any).upside_score;
  return isFiniteNumber(value) ? value : undefined;
}
